/**
 * Design System InterEquipe
 * Cores extraídas da logomarca do catavento
 * Uso: Cores suaves com transparência para elegância
 */

// Cores principais da marca (do catavento)
export const BRAND_COLORS = {
  coral: {
    solid: '#E8A598',
    text: '#7A3527',
    bg: 'rgba(232, 165, 152, 0.12)',
    bgHover: 'rgba(232, 165, 152, 0.18)',
    border: 'rgba(232, 165, 152, 0.25)',
    light: 'rgba(232, 165, 152, 0.08)',
  },
  blue: {
    solid: '#7EB3D8',
    text: '#1E4C6E',
    bg: 'rgba(126, 179, 216, 0.12)',
    bgHover: 'rgba(126, 179, 216, 0.18)',
    border: 'rgba(126, 179, 216, 0.25)',
    light: 'rgba(126, 179, 216, 0.08)',
  },
  yellow: {
    solid: '#F0E68C',
    text: '#7A7015',
    bg: 'rgba(240, 230, 140, 0.15)',
    bgHover: 'rgba(240, 230, 140, 0.22)',
    border: 'rgba(240, 230, 140, 0.30)',
    light: 'rgba(240, 230, 140, 0.10)',
  },
  green: {
    solid: '#7FBF7F',
    text: '#266126',
    bg: 'rgba(127, 191, 127, 0.12)',
    bgHover: 'rgba(127, 191, 127, 0.18)',
    border: 'rgba(127, 191, 127, 0.25)',
    light: 'rgba(127, 191, 127, 0.08)',
  },
  pearl: {
    solid: '#E2E4E9',
    text: '#52525B',
    bg: 'rgba(226, 228, 233, 0.5)',
    bgHover: 'rgba(226, 228, 233, 0.7)',
    border: 'rgba(226, 228, 233, 0.8)',
    light: 'rgba(226, 228, 233, 0.3)',
  },
};

// Cores por perfil de usuário
export const PROFILE_COLORS = {
  administrador: BRAND_COLORS.yellow,
  recepcao: BRAND_COLORS.blue,
  profissional: BRAND_COLORS.green,
  paciente: BRAND_COLORS.coral,
};

// Cores para status
export const STATUS_COLORS = {
  success: BRAND_COLORS.green,
  warning: BRAND_COLORS.yellow,
  error: BRAND_COLORS.coral,
  info: BRAND_COLORS.blue,
  neutral: BRAND_COLORS.pearl,
};

// Cores para especialidades
export const SPECIALTY_COLORS = {
  'Psicologia': BRAND_COLORS.coral,
  'Fonoaudiologia': BRAND_COLORS.blue,
  'Terapia Ocupacional': BRAND_COLORS.green,
  'Nutrição': BRAND_COLORS.yellow,
  'Psicopedagogia': BRAND_COLORS.coral,
  'Musicoterapia': BRAND_COLORS.blue,
};

// Função para obter cor por especialidade
export const getSpecialtyColor = (specialty) => {
  return SPECIALTY_COLORS[specialty] || BRAND_COLORS.pearl;
};

// Função para obter cor por perfil
export const getProfileColor = (perfil) => {
  return PROFILE_COLORS[perfil] || BRAND_COLORS.pearl;
};

// Estilos de card padrão
export const CARD_STYLES = {
  base: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(226, 228, 233, 0.6)',
    borderRadius: '1rem',
  },
  hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px -5px rgba(0, 0, 0, 0.08)',
  },
};

// Estilos de botão padrão
export const BUTTON_STYLES = {
  primary: {
    backgroundColor: '#18181B',
    color: '#FFFFFF',
    borderRadius: '9999px',
  },
  secondary: {
    backgroundColor: 'transparent',
    color: '#52525B',
    border: '1px solid #E2E4E9',
    borderRadius: '9999px',
  },
  ghost: {
    backgroundColor: 'transparent',
    color: '#52525B',
    borderRadius: '0.75rem',
  },
};

// URL da logomarca oficial
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_clinical-scheduler/artifacts/dh1ga4hw_LOGO_interequipe-removebg_sem%20nome.png';

// Tipografia
export const TYPOGRAPHY = {
  heading: {
    fontFamily: 'Outfit, sans-serif',
    fontWeight: 600,
    color: '#18181B',
  },
  body: {
    fontFamily: 'Manrope, sans-serif',
    fontWeight: 400,
    color: '#52525B',
  },
  small: {
    fontFamily: 'Manrope, sans-serif',
    fontWeight: 400,
    color: '#A1A1AA',
    fontSize: '0.75rem',
  },
};

export default {
  BRAND_COLORS,
  PROFILE_COLORS,
  STATUS_COLORS,
  SPECIALTY_COLORS,
  getSpecialtyColor,
  getProfileColor,
  CARD_STYLES,
  BUTTON_STYLES,
  LOGO_URL,
  TYPOGRAPHY,
};
